import { z } from "zod";

/**
 * One-call onboarding of a provisioned retailer (ADR-8): the steps provisioning writes to
 * OrganizationSettings.onboarding, the catalog worker moves, the partner console and API show,
 * and `organization.ready` carries as `data.onboarding`. Defined once here, a leaf both the api
 * and the jobs worker import.
 */
export const ONBOARDING_STEPS = ["sync", "enrich", "embed"] as const;
export type OnboardingStepName = (typeof ONBOARDING_STEPS)[number];

export const ONBOARDING_STATUSES = [
	"pending",
	"running",
	"done",
	"skipped",
	"failed",
] as const;
export type OnboardingStatus = (typeof ONBOARDING_STATUSES)[number];

export const onboardingSchema = z.array(
	z.object({
		step: z.enum(ONBOARDING_STEPS),
		status: z.enum(ONBOARDING_STATUSES),
		error: z.string().optional(),
		updatedAt: z.string(),
	}),
);
export type Onboarding = z.infer<typeof onboardingSchema>;

/** The stored steps, or null when there are none or they do not parse. */
export function parseOnboarding(value: unknown): Onboarding | null {
	const parsed = onboardingSchema.safeParse(value);
	return parsed.success ? parsed.data : null;
}
